/** 独立 AIGC 前端站点首页（aigc.ibaicloud.com） */
export function getAigcFrontHomeUrl() {
  const raw = process.env.AIGC_FRONT_URL || "https://aigc.ibaicloud.com/";
  const base = String(raw).replace(/\/+$/, "");
  return `${base}/#/aigc/home`;
}

export function redirectToAigcFrontHome(replace) {
  const url = getAigcFrontHomeUrl();
  if (replace) {
    window.location.replace(url);
  } else {
    window.location.href = url;
  }
}

/** console 旧地址 #/aigc/home、#/aigc → 独立站点首页 */
export function isLegacyConsoleAigcHomeRoute(to) {
  if (!to) return false;
  if (to.name === "lm_home") return true;
  const path = String(to.path || "").replace(/\/+$/, "") || "/";
  return path === "/aigc/home" || path === "/aigc";
}



// WEBPACK FOOTER //
// ./src/util/aigcFrontUrl.js